import Associates from "./Associates";
import CallToAction from "./CallToAction";
import LoanSteps from "./Loansteps";
import { useNavigate } from "react-router-dom";

const ServicePage = () => {
    const navigate = useNavigate();

    const loanData = [
        {
            title: "Home Loan - Your Dream Home Awaits",
            description: "Secure a home loan with competitive rates and expert guidance. Whether buying a new home or refinancing, we make the process simple and stress-free.",
            icon: "fa-home",
            link: "/home-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Commercial Loan - Boost Your Business",
            description: "Flexible commercial financing solutions for businesses. Access funds for operations, expansion, and investments with low-interest rates and quick approvals.",
            icon: "fa-building",
            link: "/commercial-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Industrial Loan - Power Your Industry",
            description: "Tailored financing for industrial projects and machinery. Competitive rates, flexible terms, and expert guidance for manufacturing and industrial growth.",
            icon: "fa-industry",
            link: "/industrial-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mortgage Loan - Smart Financing for Homeowners",
            description: "Flexible mortgage solutions designed for homeowners. Benefit from low-interest rates, easy approvals, and expert assistance tailored to your needs.",
            icon: "fa-hand-holding-dollar",
            link: "/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Business Loan - Fuel Your Growth",
            description: "Empower your business with tailored financing solutions. Access working capital, expansion funds, and equipment financing with expert support.",
            icon: "fa-briefcase",
            link: "/business-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Balance Transfer – Reduce Your Interest",
            description: "Transfer your existing loans to better rates with our balance transfer services. Save on interest and manage your finances efficiently.",
            icon: "fa-exchange-alt",
            link: "/balance-transfer-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Construction Funding - Build Your Projects",
            description: "Secure funding for your construction projects with competitive rates and expert guidance. From residential to commercial builds, we provide tailored solutions.",
            icon: "fa-tools",
            link: "/construction-funding-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Education Loan - Invest in Your Future",
            description: "Affordable student loan options for higher education. Low-interest rates, easy application process, and flexible repayment plans available.",
            icon: "fa-graduation-cap",
            link: "/education-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Commercial Vehicle Loans - Drive Your Business Forward",
            description: "Financing solutions for commercial vehicles. Competitive rates, flexible terms, and quick approvals for personal and business transportation needs.",
            icon: "fa-truck",
            link: "/commercial-vehicle-loans-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Car Loan - Drive Your Dream Today",
            description: "Get instant financing to own your dream car. Flexible EMIs, attractive interest rates, and quick approval process.",
            icon: "fa-car",
            link: "/car-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Personal Loan - Quick & Hassle-Free Approval",
            description: "Personalized loan solutions with flexible repayment options and competitive interest rates. No hidden fees and fast approvals with Magnify Advisory .",
            icon: "fa-wallet",
            link: "/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Property Search - Find Your Ideal Property",
            description: "Find your ideal property with our expert search services. Comprehensive listings, market insights, and personalized assistance to help you discover the perfect home or investment.",
            icon: "fa-search-location",
            link: "/property-search-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "ReDevelopment consultancy - Transform Your Property",
            description: "Expert redevelopment consultancy services for property transformation. From planning to execution, we provide comprehensive solutions for residential and commercial redevelopment projects.",
            icon: "fa-building",
            link: "/redevelopment-consultancy-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Sole selling agent of entire project - Exclusive Representation",
            description: "As the sole selling agent for entire projects, we provide exclusive representation and marketing services to ensure successful sales and maximum returns for developers and property owners.",
            icon: "fa-user-tie",
            link: "/sole-selling-agent-entire-project-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Life Insurance - Secure Your Future",
            description: "Life insurance plans to protect your loved ones and secure your financial future. Choose from term life, whole life, and endowment policies with competitive premiums.",
            icon: "fa-heartbeat",
            link: "/life-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "General Insurance - Protect What Matters",
            description: "Comprehensive general insurance solutions covering health, vehicle, property, and more. Protect what matters with affordable premiums and reliable coverage.",
            icon: "fa-shield-alt",
            link: "/general-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mutual Funds - Grow Your Wealth",
            description: "Invest in mutual funds for diversified portfolios and long-term growth. Expert advice on equity, debt, and hybrid funds to meet your financial goals.",
            icon: "fa-chart-line",
            link: "/mutual-funds-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Property Exhibition - Showcase Your Properties",
            description: "Professional property exhibition services to highlight your listings. Engage potential buyers with stunning displays and expert marketing strategies.",
            icon: "fa-search-location",
            link: "/property-exhibition-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Property Insurance - Safeguard Your Assets",
            description: "Comprehensive property insurance covering residential and commercial properties. Protect against damages, theft, and natural disasters with reliable coverage.",
            icon: "fa-shield-alt",
            link: "/property-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Health Insurance - Secure Your Well-being",
            description: "Affordable health insurance plans for individuals and families. Coverage for medical expenses, hospitalization, and preventive care with top providers.",
            icon: "fa-heartbeat",
            link: "/health-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Vehicle Insurance - Protect Your Ride",
            description: "Reliable vehicle insurance for cars, bikes, and more. Comprehensive coverage including third-party liability, own damage, and add-on benefits.",
            icon: "fa-car",
            link: "/vehicle-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Loan Against Securities - Unlock Your Investments",
            description: "Get loans against your securities and investments. Flexible terms, competitive rates, and quick disbursal for financial needs without selling assets.",
            icon: "fa-chart-line",
            link: "/loan-against-securities-mumbai-thane-palghar-maharashtra-delhi-india",
        },
    ];

    return (
        <>
            <div className="other-pages-main-section service-page-fin">
                <h2 className="other-pages-title">Our Services</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/loan-services-india")} style={{ cursor: "pointer" }}>Services</span>
                </p>
            </div>

            <Associates />

            <div className="loan-card-main">
                <h2 className="sections-title-smco">
                    <span className="horizontal-line"></span>Our Core Services
                </h2>
                <p className="sections-description-smco">
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </p>

                <div className="loan-cards-container-smco">
                    {loanData.map((loan, index) => (
                        <div
                            key={index}
                            className="loan-card-smco"
                            onClick={() => navigate(loan.link)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="loan-card-container-icon-dashed-border">
                                <div className="loan-card-icon-container-smco">
                                    <i className={`fa-solid ${loan.icon} loan-card-icon-smco`}></i>
                                </div>
                            </div>
                            <h3 className="loan-card-title-smco">{loan.title}</h3>
                            <p className="loan-card-description-smco">{loan.description}</p>

                            {/* Learn More Button */}
                            <button
                                className="loan-card-button-smco"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                Learn More
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default ServicePage;
